import React, { useEffect, useState } from 'react'
import { Button } from '../../../../components/ui/button'
import { Tablist, TablistItem } from '../../../../components/ui/tablist'
import Manual from './filters/Manual';
import Spread from './filters/Spread';
import { Breadcrumb } from '../../../../components/ui/breadcrumb';
import { useNavigate } from 'react-router-dom';
import Concept from './concept/Concept';
import PreviousPickups from './pickups/PreviousPickups';
import toast, { Toaster } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { CONFIG } from '../../../../config';
import { Tab, TabItem } from '../../../../components/ui/tab';
import { useQuery } from '@tanstack/react-query';
import axios from '../../../../lib/axios';
import useAuth from '../../../../hooks/useAuth';
import AnnounceForeignCurrencyForm from './foreign-currency/AnnounceForeignCurrencyForm';

const Main = () => {
  const { auth } = useAuth()
  const {t} = useTranslation()
  const navigate = useNavigate()

  const [type_order, settype_order] = useState<'eur' | 'foreign'>(() =>
    CONFIG.order_and_collect.order.enable_foreign_currency
      ? ((window.sessionStorage.getItem('ophaling-aankondigen-tab') as 'eur' | 'foreign') || 'eur')
      : 'eur'
  );
  useEffect(() => { window.sessionStorage.setItem('ophaling-aankondigen-tab', type_order) }, [type_order]);

  const [selected_subpage, setselected_subpage] = useState<Subpage>('manual');
  const [selected_draft, setselected_draft] = useState<AnnouncementDraftSearch>()
  const [eur_partner, seteur_partner] = useState<string | null>(null);
  const [eur_customer, seteur_customer] = useState<string | null>(null);

  const { data:kassas } = useQuery<Kassa[] | null>({
    queryKey: ['user-kassa'],
    queryFn: async () => {
      try {
        if(!CONFIG.order_and_collect.order.enable_foreign_currency){ return null }
        const {data} = await axios.get(`kassa/get`, { params: {
          token: auth.data?.token,
          relnr: auth.data?.partner
        }})
        if(data.errorcode !== 0) { throw new Error(data.errorcode) }
        if(!Array.isArray(data.object)) { console.log('geen kassa ingesteld'); throw new Error() }

        return data.object
      } catch (err) {
        console.log(err)
        return null
      }
    }
  })

  function editDraft(draft:AnnouncementDraftSearch) {
    setselected_draft(draft);
    setselected_subpage('manual');
  }

  function editForeignDraft(draft:AnnouncementDraftSearch) {
    settype_order('foreign');
    setselected_draft(draft);
  }
  
  useEffect(()=>{
    if(selected_draft){ setselected_draft(undefined) }
  }, [selected_draft])

  return (
    <>
    <Toaster />
    <div className='relative w-full p-4 overflow-auto md:p-8'>

        <Breadcrumb items={[{title:<p onClick={()=>{navigate('/bestellen-en-ophalen')}} className='cursor-pointer'>{t("order_and_pickup.o_announce_pickup.link_orders")}</p>}, {title:t("order_and_pickup.o_announce_pickup.link_announce")}]}/>
        <h1 className='text-2xl font-semibold'>{t("order_and_pickup.o_announce_pickup.title")}</h1>

        {CONFIG.order_and_collect.order.enable_foreign_currency &&
        <>
        {kassas?.some(i=>i.kassaactive) && 
        <div className='translate-y-4'>
          <Tab value={type_order} onValueChange={(value)=>{settype_order(value as 'eur' | 'foreign')}}>
            <TabItem value='eur'>EUR</TabItem>
            <TabItem value='foreign'>{t("order_and_pickup.o_announce_pickup.foreign_currency")}</TabItem>
          </Tab>
        </div>
        }
        </>
        }

        {type_order === 'foreign' &&
        <div className='flex flex-col gap-4 p-4 mt-4 border rounded-sm shadow-sm md:mt-8'>
          <AnnounceForeignCurrencyForm defaultDraft={selected_draft} defaultPartner={eur_partner} defaultCustomer={eur_customer}/>
        </div>
        }

        {type_order === 'eur' &&
        <div className='flex flex-col gap-4 p-4 mt-4 border rounded-sm shadow-sm md:mt-8'>
            <Tablist onValueChange={(value)=>{setselected_subpage(value as Subpage)}} value={selected_subpage}>
                <TablistItem value='manual'>{t("order_and_pickup.o_announce_pickup.manual")}</TablistItem>
                <TablistItem value='spreadsheet'>{t("order_and_pickup.o_announce_pickup.spreadsheet")}</TablistItem>      
            </Tablist>
            
            <div className={`${selected_subpage !== 'manual' && 'hidden'}`}><Manual defaultDraft={selected_draft} onPartnerChange={seteur_partner} onCustomerChange={seteur_customer}/></div>
            <div className={`${selected_subpage !== 'spreadsheet' && 'hidden'}`}><Spread /></div>
        </div>
        }

        <PreviousPickups selectedTab={type_order} />

        <Concept selectedTab={type_order} onEditForeign={(draft)=>{ editForeignDraft(draft) }} onEdit={(draft)=>{editDraft(draft)}}/>
    </div>
    </>
  )
}

export default Main

type Subpage = 'manual' | 'spreadsheet'